interface IOption {
  scrollWidth: number;
  scrollTrackWidth: number;
  scrollTrackHeight: number;
  background: string;
  thumbColor: string;
  borderRadius: number;
  maxRatio: number;
  minRatio: number;
  maxShowRatio: number;
  scrollFn: Function | null;
}
interface IStyle {
  [key: string]: string;
}

const setStyle = (dom: HTMLElement, style: IStyle) => {
  Object.keys(style).forEach(key => {
    dom.style[key] = style[key];
  })
}

const defaultOption = {
  scrollWidth: 650, // 矩形树图滚动宽度
  scrollTrackWidth: 24, // 滚动条轨道宽度
  scrollTrackHeight: 3, // 滚动条高度
  borderRadius: 1.5, // 滚动条圆角
  background: 'rgba(0,0,0,0.08)', // 滚动条轨道背景颜色
  thumbColor: '#FF2436', // 滚动条滑块颜色
  maxRatio: 0.8, // 最大展示比例，最大方块超过该比例，不显示滚动条
  minRatio: 0.5, // 最小展示比例，最大方块小于该比例，使用scrollWidth宽度滚动
  maxShowRatio: 0.9, // minRatio，maxRatio之间自适应后最大方块占首屏的比例
  scrollFn: null,
}

export default class scrollHelper {
  private chart: any;
  private dom: HTMLElement;
  private scrollBarDom: HTMLElement;
  private option: IOption;
  private scrollBarThumb: HTMLElement;
  constructor(chart: any, scrollBarDom: HTMLElement, option: IOption) {
    this.chart = chart;
    this.dom = chart.getDom();
    this.scrollBarDom = scrollBarDom;
    this.option = { ...defaultOption, ...option };
    this.scrollBarThumb = null;

    this.init();
  }

  init() {
    const { scrollTrackWidth, scrollTrackHeight, background, thumbColor, borderRadius } = this.option;
    setStyle(this.scrollBarDom, {
      display: 'none',
      ['align-items']: 'center',
      ['justify-content']: 'center',
    })
    
    const scrollBarTrack = document.createElement('div');
    setStyle(scrollBarTrack, {
      width: `${scrollTrackWidth}px`,
      height: `${scrollTrackHeight}px`,
      background: background,
      ['border-radius']: `${borderRadius}px`,
    })
    this.scrollBarThumb = document.createElement('div');
    setStyle(this.scrollBarThumb, {
      height: `${scrollTrackHeight}px`,
      background: thumbColor,
      ['border-radius']: `${borderRadius}px`,
    })
    scrollBarTrack.append(this.scrollBarThumb);
    this.scrollBarDom.append(scrollBarTrack);
  }

  update() {
    const { maxRatio, minRatio, maxShowRatio, scrollWidth } = this.option;
    const domWidth = this.dom.parentElement.offsetWidth;
    if (domWidth < scrollWidth) {
      // 需要滚动
      const echartsIns = this.chart.getECharts();
      const data = echartsIns.getOption().series[0].data;
      let maxValue = 0;
      const total = data.reduce((res, i) => {
        maxValue = Math.max(maxValue, i.value);
        return res + i.value
      }, 0)
      const maxValueRatio = maxValue / total;
      if (maxValueRatio > maxRatio) {
        // 单屏展示
        this.singleShow();
      } else if(maxValueRatio > minRatio) {
        // 进行适配
        this.scrollShow(domWidth, domWidth / (maxValueRatio / maxShowRatio));
      } else {
        // 按照scrollWidth进行滚动
        this.scrollShow(domWidth, scrollWidth);
      }
    } else {
      // 超出宽度，单屏展示
      this.singleShow();
    }
    this.chart.getECharts().resize()
  }

  singleShow() {
    setStyle(this.dom, {
      width: '100%',
    })
    setStyle(this.scrollBarDom, {
      display: 'none',
    })
  }

  scrollShow(domWidth, scrollWidth) {
    const { scrollTrackWidth, scrollFn } = this.option;
    setStyle(this.scrollBarDom, {
      display: 'flex',
    })
    setStyle(this.scrollBarDom, {
      display: 'flex',
    })
    setStyle(this.dom, {
      width: `${scrollWidth}px`
    })
    this.dom.parentElement.onscroll = (e) => {
      setStyle(this.scrollBarThumb, {
        ['margin-left']: `${(e.target as any).scrollLeft / scrollWidth * scrollTrackWidth}px`,
      })
      scrollFn && scrollFn();
    }
    setStyle(this.scrollBarThumb, {
      width: `${domWidth / scrollWidth * scrollTrackWidth}px`,
    })
    this.dom.parentElement.scrollLeft = 0;
  }
}